import { observer } from 'mobx-react';
import { computed, action } from 'mobx';
import { bind, inject } from '../../../../utils/decorators';
import * as React from 'react';
import { InputGroup, FormControl, Table, Panel, FormGroup } from 'react-bootstrap';
import { BpsReferenzkraftKalibrierungRili2021Store } from '../../../../stores/BpsReferenzkraftKalibrierungRili2021Store';
import * as ApiTypesBps from '../../../../models/ApiTypesBps2021';

@observer
class BpsPruefortParameterKomponente extends React.Component<{ ziel: ApiTypesBps.IBpsReferenzkraftPruefortParameterKomponente; beschriftung: string; einheit: string; }, {}> {
  @inject(BpsReferenzkraftKalibrierungRili2021Store) store: BpsReferenzkraftKalibrierungRili2021Store;
  @bind @action handleIstWertChange(ev: React.FormEvent<FormControl>) {
    this.props.ziel.wert = (ev.target as HTMLInputElement).value !== '' ? (ev.target as HTMLInputElement).valueAsNumber : null;
  }
  @computed get imToleranzbereich() {
    const { wert, min, max } = this.props.ziel;
    if ((wert !== null) && ((wert < min) || (wert > max))) {
      return false;
    }
    return true;
  }
  public render() {
    const { wert, min, max } = this.props.ziel;
    return (
      <tr>
        <td className="beschriftung">{this.props.beschriftung}</td>
        <td className="min">{min}</td>
        <td className="messwert">
          <FormGroup validationState={wert === null ? 'error' : undefined}>
            <InputGroup>
              <FormControl
                type="number"
                step="any"
                readOnly={this.store.readOnly}
                onChange={this.handleIstWertChange}
                value={wert !== null ? wert : ''}
                className={wert !== null && this.imToleranzbereich === true ? 'text-success' : 'text-danger'}
              />
              <InputGroup.Addon>{this.props.einheit}</InputGroup.Addon>
            </InputGroup>
          </FormGroup>
        </td>
        <td className="max">{max}</td>
      </tr>
    );
  }
}

/** Exportierte Komponente für Eingabe und Validierung der Prüfortparameter Kalibrierung Bremsenprüfstand */
@observer
export default class BpsPruefortParameter extends React.Component<{ titel: string; ziel: ApiTypesBps.IBpsReferenzkraftPruefortParameter; }, {}> {
  public render() {
    return(
      <Panel header={this.props.titel} collapsible={true} defaultExpanded={true}>
        <Table striped={false} bordered={false} condensed={true} hover={false} className="bps-pruefortparameter">
          <thead>
            <tr>
                <th/>
                <th>Min.</th>
                <th>Messwert</th>
                <th>Max.</th>
            </tr>
          </thead>
          <tbody>
            <BpsPruefortParameterKomponente ziel={this.props.ziel.lufttemperatur} beschriftung="Lufttemperatur" einheit="°C"/>
            <BpsPruefortParameterKomponente ziel={this.props.ziel.luftfeuchtigkeit} beschriftung="Luftfeuchtigkeit" einheit="%"/>
          </tbody>
        </Table>
      </Panel>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/rili2021/BpsPruefortParameter.tsx